import {Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {googleSiteVerification} from '@environment';
import {filter, map, mergeMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  constructor(private titleService: Title, private meta: Meta, private router: Router, private activatedRoute: ActivatedRoute) {
    this.meta.updateTag({
      name: 'google-site-verification',
      content: googleSiteVerification,
    });
  }

  updateMetaInfo(
    content = 'Herzlich willkommen zu Ihrem Toyota Financial Services Portal. Erleben Sie unseren digitalen Kundenservice - mit vielen Möglichkeiten und neuem Design.',
  ): void {
    this.meta.updateTag({name: 'description', content: content});
  }

  updateTitle(title?: string): void {
    if (!title) {
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => this.activatedRoute),
          map(route => {
            while (route.firstChild) {
              route = route.firstChild;
            }
            return route;
          }),
          filter(route => route.outlet === 'primary'),
          mergeMap(route => route.data),
        )
        .subscribe(data => {
          const title = data.title ? data.title + ' | Toyota Financial Services' : 'TFS Portal 2.0';
          this.titleService.setTitle(title);
          this.updateMetaInfo(data['description']);
        });
    } else {
      this.titleService.setTitle(title + ' | Toyota Financial Services');
    }
  }
}
